(function () {
  "use strict";

  angular
    .module("virtualFairs")
    .controller(
      "VirtualFairPlatformSyncController",
      VirtualFairPlatformSyncController
    );

  VirtualFairPlatformSyncController.$inject = [
    "VirtualFairService",
    "API_BASE"
  ];

  function VirtualFairPlatformSyncController(
    VirtualFairService,
    API_BASE
  ) {
    var vm = this;
    vm.queryFlag = false;
    vm.expos = "";
    vm.selectExpo = selectExpo;
    vm.getByFilter = getByFilter;
    vm.stopSync = stopSync;
    vm.integrations = [
      { id: "exhibitors", name: "Exhibitors" },
      { id: "students", name: "Students" },
      { id: "areas-of-interest", name: "Areas of Interest" },
      { id: "cities", name: "Cities" },
      { id: "countries", name: "Countries" },
      // { id: 'matches', name: 'Matches' },
      { id: "networking-events-meetings", name: "Networking Events Meetings" },
      // { id: 'profile-types', name: 'Profile Types' },
      { id: "regions", name: "Regions" },
      // { id: 'scholarities', name: 'Scholarities' },
      // { id: "university-connect", name: "University Connect" },
    ];
    vm.confirmedOptions = [
      { id: -1, name: "--- All ---" },
      { id: 1, name: "Confirmed" },
      { id: 0, name: "Pending" },
    ];
    vm.syncStatusOptions = [
      { id: -1, name: "--- All ---" },
      { id: 1, name: "Synchonized" },
      { id: 0, name: "Not Synchonized" },
    ];
    // Students
    vm.studentsOptions = [
      { id: -1, name: "--- All ---" },
      { id: 1, name: "Sync Students to test" },
      { id: 2, name: "Sync specific Student" },
    ],
    vm.studentsOptionsSelected = -1;
    vm.studentId = null;
    // EXHIBITORS
    vm.exhibitorsOptions = [
      { id: -1, name: "--- All ---" },
      { id: 1, name: "Sync specific Exhibitor" },
    ],
    vm.exhibitorsOptionsSelected = -1;
    vm.exhibitorId = null;
    // NETWORK
    vm.networkingOptions = [
      { id: 1, name: "Sync Partners" },
      { id: 2, name: "Sync Meetings" },
    ],
    vm.networkingOptionsSelected = 1;


    vm.integrationSelected = "";
    vm.confirmedSelected = { id: -1, name: "--- All ---" };
    vm.search = "";
    vm.syncStatusSelected = "";
    vm.synchronizing = false;
    vm.synchronized = 0;
    vm.syncError = 0;
    vm.syncTotal = 0;
    vm.syncData = syncData;
    vm.syncItem = syncItem;
    vm.formatDate = formatDate;
    vm.selectIntegration = selectIntegration;
    vm.getCountries = getCountries;
    vm.countries = [];
    vm.countrySelected = "";
    vm.syncRequests = [];

    function activate() {
      vm.selectExpo();
    }

    async function selectIntegration() {
      vm.syncItems = false;
      vm.queryFlag = false;
      if (
        vm.integrationSelected == "regions" ||
        vm.integrationSelected == "cities"
      ) {
        if (vm.countries.length == 0) {
          await vm.getCountries();
        }
      }
    }

    function selectExpo() {
      VirtualFairService.platformSyncFairs()
        .then(function (response) {
          vm.expos = [];
          vm.expos = response.data;
        })
        .catch(function (error) {
          console.error(error);
        });
    }

    function getByFilter() {

      vm.queryFlag = false;
      let url = 'https://fppadmin.fpp.world/integration-api/';
      switch (vm.integrationSelected) {
        case 'students' : {
          if(vm.studentsOptionsSelected == 1) {
            url += `students/${vm.expoSelected.id}?students_test=1`
          } if(vm.studentsOptionsSelected == 2) {
            url += `students/${vm.expoSelected.id}?expo_student_virtual_fair_id=${vm.studentId}`
          } if (vm.studentsOptionsSelected == -1) {
            url += `students/${vm.expoSelected.id}`
          }
          break;
        }
        case 'exhibitors' : {
          if(vm.exhibitorsOptionsSelected == 1) {
            url += `exhibitors/${vm.expoSelected.id}?expos_users_virtual_fair_id=${vm.exhibitorId}`
          } else {
            url += `exhibitors/${vm.expoSelected.id}`
          }
          break;
        }
        case 'regions' : {
          url += `regions/${vm.expoSelected.id}?country_id=${(vm.countrySelected.id).toLowerCase()}`
          break;
        }
        case 'cities' : {
          url += `cities/${vm.expoSelected.id}?country_id=${(vm.countrySelected.id).toLowerCase()}`
          break;
        }
        case 'networking-events-meetings' : {
          if(vm.networkingOptionsSelected == 1) {
            url += `university_connect/${vm.expoSelected.id}`
          } if(vm.networkingOptionsSelected == 2) {
            url += `networking_events/${vm.expoSelected.id}`
          }
          break;
        }
        case 'networking-events-meetings' : {
          if(vm.networkingOptionsSelected == 1) {
            url += `university_connect/${vm.expoSelected.id}`
          } if(vm.networkingOptionsSelected == 2) {
            url += `networking_events/${vm.expoSelected.id}`
          }
          break;
        }
        case 'areas-of-interest' : {
          url += `areas-of-interest/${vm.expoSelected.id}`
          break;
        }
        case 'countries' : {
          url += `countries/${vm.expoSelected.id}`
          break;
        }
      }
      // console.log(url);
      window.open(url, '_blank').focus();
    }

    async function syncData(items) {
      vm.queryFlag = true;
      for (let i = 0; i < items.length; i++) {
        if (vm.synchronizing) {
          await vm.syncItem(items[i]);
        }
      }
      vm.synchronizing = false;
    }

    async function syncItem(item) {
      if (!item) {
        return false;
      }
      item.loading = true;
      vm.syncItems.unshift(item);
      let id = item.id;
      if (vm.integrationSelected.id == "cities") {
        id = `${item.country_id}_${item.region_id}_${item.id}`;
      }
      let request = await VirtualFairService.platformSyncExec(
        vm.expoSelected.id,
        vm.integrationSelected.id,
        id
      )
        .then((response) => {
          item.loading = false;
          if (response.data.error) {
            vm.syncError++;
            item.error = response.data.error;
          } else {
            vm.synchronized++;
          }
          item.response = response.data;
          return item;
        })
        .catch((err) => {
          item.loading = false;
          vm.syncError++;
          item.error = err;
          return item;
        });
      vm.syncRequests.push(request);
    }

    function formatDate(date) {
      return moment(date).format("hh:mm");
    }

    async function getCountries() {
      await VirtualFairService.countries().then(function (response) {
        vm.countries = [];
        vm.countries = response.data;
      });
    }

    async function stopSync() {
      vm.synchronizing = false;
      return false;
    }

    activate();
  }
})();
